import React from "react";
import { InfiniteScrollSelectProps } from "@design-system";
import { useUserSearchQuery } from "../../hooks";
import { Select } from "antd";

export const UsersSelectContainer: React.FC<
  InfiniteScrollSelectProps<any> & {
    requiredUsers?: { id: number; displayName: string }[];
    externalMatterId?: number;
    clientId?: number;
  }
> = ({ requiredUsers = [], externalMatterId, clientId, ...others }) => {
  const { search, loading, users } = useUserSearchQuery(requiredUsers, externalMatterId, clientId);
  return (
    <Select
      {...others}
      placeholder="Start typing to see Users that match your search term"
      loading={loading}
      mode="multiple"
      options={users?.map(({ id, displayName }) => ({ label: displayName, value: id })) || []}
      showSearch
      onSearch={(value) => {
        value !== "" && search(value);
      }}
      filterOption={false}
    />
  );
};
